// Units sorted by most commonly used first (for smart prefix search).
export const UNITS = [
  "NOS", "PCS", "PACK", "PAIR",
  "KGS", "GRAM", "TON",
  "MM", "MTR", "ML", "CM",
  "LTR",
  "BOX", "BAG", "BUNDLE",
  "SQFT", "SQM", "SET", "SHEET",
  "RFT", "ROLL",
  "CARTON", "CAN", "COIL", "DRUM",
  "DOZEN", "UNIT", "FEET", "INCH", "BTL",
];
